module.exports = __webpack_public_path__ + "static/media/professional-image.5529be7f.jpg";